<template>
  <ModalDefault modal_id="exampleApiModal"
                header="y"
                size="modal-md modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_1064')"
                footer=""
                icon="bx bx-code-alt mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div>
        <div class=" d-flex">
          <div class="cursor-default w-100"  style="align-items: center; align-self: center;">
            <div class="d-block pt-0 px-2">
              <div v-if="example === 1" class="col-12 px-0">
                <div class="pb-1">
                  <h6 class="title-color">
                    {{ getTranslations('expression_1060') }}:
                  </h6>
                </div>
    <vue-code-highlight v-if="example === 1" language="javascript"><pre>
    {
      name: 'John Doe',
      phone: '5511900000000',
      text: 'Hello!',
      file: 'https://mylink.com/image.jpg',
    }
    </pre></vue-code-highlight>
              </div>
              <div v-if="example === 2" class="col-12 px-0">
                <div class="pb-1">
                  <h6 class="title-color">
                    {{ getTranslations('expression_1061') }}:
                  </h6>
                </div>
    <vue-code-highlight language="javascript"><pre>
    {
      partner_id: 1,
      message: 'Received',<!--      description: 'The message has been received.',-->
      data: {
          name: 'John Doe',
          phone: '5511900000000',
          text: 'Hello!',
          file: 'https://mylink.com/image.jpg',
        }
    }
    </pre></vue-code-highlight>
              </div>
              <div v-if="example === 3 || example === 4" class="col-12 px-0">
                <div class="pb-1">
                  <h6 class="title-color">
                    {{ example === 3 ? getTranslations('expression_1121') : getTranslations('expression_1122')}}:
                  </h6>
                </div>
    <vue-code-highlight language="javascript"><pre>
    {
      message: 'sent',
      data: {
          text: 'Hello!',
          file: 'https://mylink.com/image.jpg',
          scheduled_at: '2021-01-01 12:00:00',
        }
    }
    </pre></vue-code-highlight>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import $ from "jquery";
import {component as VueCodeHighlight} from "vue-code-highlight";
import "vue-code-highlight/themes/duotone-sea.css";
import "vue-code-highlight/themes/window.css";

export default {
  name: "ModalExampleApi",
  components: {
    ModalDefault,
    VueCodeHighlight,
  },
  data() {
    return {
      example: null
    }
  },
  mounted() {
    this.$root.$on('showExample',(payload)=> {
      this.example = payload;
    });
    $('#exampleApiModal').on('hidden.bs.modal', () => {
      this.example = null
    })
  },
  computed: {
    ...mapState(['channels', 'departments', 'interests']),
  },
  methods: {

  }
}
</script>


<style>
div pre[class*="language-"] {
  padding-left: 25px;
  padding-bottom: 10px;
  padding-top: 50px;
  width: 100%;
  border-radius: 15px !important;
  -webkit-box-shadow: none;
  box-shadow: none;
  overflow-x: auto!important;
  /*-webkit-box-shadow: 0 5px 15px -2px rgba(0, 0, 0, 0.1)!important;*/
  /*box-shadow: 0 5px 15px -2px rgba(0, 0, 0, 0.1)!important;;*/
}
</style>
